import _DevelopmentMediaLinkService from "../services/development-media-link-service";
import { IDevelopmentMediaLinkService } from "../types/services/development-media-link-service";

const instance = new _DevelopmentMediaLinkService();

const DevelopmentMediaLinkService: IDevelopmentMediaLinkService = instance;

export default DevelopmentMediaLinkService;
